import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../constants/typography';
import {SizeRun} from './SizeRun';
import {SizeRunCluster} from './types';

export const SizeClusters: FC<{
  activeFilters: Map<string, Array<string> | undefined>;
  clusters?: Array<SizeRunCluster>;
  onSizeClick: (slug: string, sizeId: string) => void;
  enableFlyoutFilter?: boolean;
}> = ({activeFilters, clusters, onSizeClick, enableFlyoutFilter}) => {
  if (!clusters) return null;

  return (
    <>
      {clusters.map((cluster, clusterIndex) => (
        <Cluster
          $withoutPadding={enableFlyoutFilter}
          data-testid={`sizeRunCluster-${cluster.label}`}
          hasBorder={clusters.length > 1 && clusterIndex !== 0}
          key={`sizeRunCluster-${cluster.label}`}
        >
          <ClusterLabel>{cluster.label}</ClusterLabel>
          {cluster.sizeRuns.map((sizeRun, sizeRunIndex) => {
            return (
              <SizeRun
                activeSizeIds={activeFilters.get(sizeRun.slug) ?? []}
                key={`filter-flyout-cluster-size-run-${sizeRun.slug}-${clusterIndex}-${sizeRunIndex}`}
                label={sizeRun.label}
                onSizeClick={id => onSizeClick(sizeRun.slug, id)}
                sizes={sizeRun.sizes}
              />
            );
          })}
        </Cluster>
      ))}
    </>
  );
};

const Cluster = styled.div<{hasBorder: boolean; $withoutPadding?: boolean}>`
  ${props =>
    props.$withoutPadding
      ? css`
          padding: 1.5rem 0;
          &:first-of-type {
            padding-top: 0;
            padding-bottom: 1.5rem;
          }
        `
      : 'padding: 1.5rem 1rem;'}
  border-top: ${({hasBorder}) =>
    hasBorder ? `1px solid ${COLORS.Grey3}` : 'none'};
`;

const ClusterLabel = styled.label`
  font-size: ${FONT_SIZES.px16};
  font-weight: ${FONT_WEIGHTS.bold};
  margin: 0 0 1rem;
`;
